export const BackgroundBeam = () => {
  return (
    <div className="absolute h-[44.875rem] top-[-4.188rem] left-1/2 -translate-x-1/2 w-[40.75rem] pointer-events-none z-0">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 852 918"
      >
        <g filter="url(#filter0_f_beam)">
          <path
            d="M486.06 100H426.346L100 818H752L486.06 100Z"
            fill="url(#paint0_linear_beam)"
            fillOpacity="0.3"
          />
        </g>

        <defs>
          <filter id="filter0_f_beam" filterUnits="userSpaceOnUse">
            <feGaussianBlur stdDeviation="50" />
          </filter>

          <linearGradient
            id="paint0_linear_beam"
            x1="413.5"
            y1="100"
            x2="413.5"
            y2="920"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--dynamic-primary)" />
            <stop offset="1" stopColor="var(--dynamic-primary)" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};